import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "18",
  viewBox: "0 0 16 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M4.42544 0.111115L5.91381 1.88889H13.1765C13.6963 1.88889 14.1176 2.28686 14.1176 2.77778V11.6879L16 13.9363V2.77778C16 1.30502 14.7359 0.111115 13.1765 0.111115H4.42544Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M7.40218 3.66667H10.2222C10.7131 3.66667 11.1111 4.06464 11.1111 4.55556C11.1111 5.04648 10.7131 5.44445 10.2222 5.44445H8.89055L7.40218 3.66667Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M12.4143 17.8889L10.9477 16.1111H3.76471C3.24491 16.1111 2.82353 15.7131 2.82353 15.2222V14.3333C3.34333 14.3333 3.76471 13.9354 3.76471 13.4444C3.76471 12.9535 3.34333 12.5556 2.82353 12.5556V9.88889C3.34333 9.88889 3.76471 9.49092 3.76471 9C3.76471 8.50908 3.34333 8.11111 2.82353 8.11111V6.26369L0.704394 3.69504C0.299214 3.7942 0 4.14188 0 4.55556C0 5.04648 0.421379 5.44445 0.941176 5.44445V8.11111C0.421379 8.11111 0 8.50908 0 9C0 9.49092 0.421379 9.88889 0.941176 9.88889V12.5556C0.421379 12.5556 0 12.9535 0 13.4444C0 13.9354 0.421379 14.3333 0.941176 14.3333V15.2222C0.941176 16.695 2.20531 17.8889 3.76471 17.8889H12.4143Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("path", {
  d: "M2.46066 0.430972C2.14638 0.053838 1.58588 0.0028834 1.20875 0.317162C0.831612 0.63144 0.780658 1.19194 1.09494 1.56907L14.4282 17.569C14.7425 17.9462 15.303 17.9971 15.6801 17.6828C16.0573 17.3686 16.1082 16.8081 15.794 16.4309L2.46066 0.430972Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5
  ]))
}